import { render, staticRenderFns } from "./ExResponsibilityBadgeHolder.vue?vue&type=template&id=db285f76"
import script from "./ExResponsibilityBadgeHolder.vue?vue&type=script&lang=js"
export * from "./ExResponsibilityBadgeHolder.vue?vue&type=script&lang=js"
import style0 from "./ExResponsibilityBadgeHolder.vue?vue&type=style&index=0&id=db285f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports